// // import React from "react";
// // import { billToFields } from "../formFields/shippmentTabsFields";
// // import GenericFormTab from "./GenericFormTab";

// // export default function BillToTab({ formData, onChange , errors = {} }) {
// //     return (
// //         <GenericFormTab
// //             fields={billToFields}
// //             formData={formData}
// //             onChange={onChange}
// //             errors={errors}
// //         />
// //     );
// // }











// import React, { useCallback, useEffect, useState } from "react";
// import { billToFields } from "../formFields/shippmentTabsFields";
// import GenericFormTab from "./GenericFormTab";

// /**
//  * BillToTab (local-checked)
//  *
//  * Keeps a local checkbox state so we DO NOT write billToSameAsDestination into formData,
//  * preventing GenericFormTab's conditional hiding from running. Copies non-empty destination
//  * fields into billTo when checked and keeps them in sync while checked.
//  */
// export default function BillToTab({ formData = {}, onChange, errors = {} , viewOnly = false , isEdit = true }) {
//     // local checked state (initialized from formData if available)
//     const [checked, setChecked] = useState(!!formData.billToSameAsDestination);

//     // call onChange for multiple fields
//     const setMultiple = useCallback((pairs = {}) => {
//         Object.entries(pairs).forEach(([name, value]) => {
//             onChange({ target: { name, value } });
//         });
//     }, [onChange]);

//     // helper: consider present if non-null/undefined and not empty-string
//     const isPresent = (v) => {
//         if (v === undefined || v === null) return false;
//         if (typeof v === "string") return v.trim() !== "";
//         return true;
//     };

//     // helpers to read flat or nested destination values
//     const getDest = (flatName, nestedName) => {
//         const flat = formData[flatName];
//         if (isPresent(flat)) return flat;
//         if (nestedName && formData.destination && isPresent(formData.destination[nestedName])) {
//             return formData.destination[nestedName];
//         }
//         return undefined;
//     };

//     // copy only non-empty destination fields into billTo (preserve existing billTo values)
//     const copyDestinationToBillTo = useCallback(() => {
//         const mapping = {};
//         const fields = [
//             ['destinationName', 'name', 'billToName'],
//             ['destinationAddressLine1', 'addressLine1', 'billToAddressLine1'],
//             ['destinationAddressLine2', 'addressLine2', 'billToAddressLine2'],
//             ['destinationAddressLine3', 'addressLine3', 'billToAddressLine3'],
//             ['destinationAddressLine4', 'addressLine4', 'billToAddressLine4'],
//             ['destinationCity', 'city', 'billToCity'],
//             ['destinationState', 'state', 'billToState'],
//             ['destinationCountry', 'country', 'billToCountry'],
//             ['destinationContact', 'contact', 'billToContact'],
//             ['destinationEmail', 'email', 'billToEmail']
//         ];

//         fields.forEach(([flat, nested, billKey]) => {
//             const destVal = getDest(flat, nested);
//             if (isPresent(destVal)) {
//                 mapping[billKey] = destVal;
//             }
//         });

//         if (Object.keys(mapping).length) setMultiple(mapping);
//     }, [formData, getDest, isPresent, setMultiple]);

//     // checkbox toggled by user
//     const handleCheckbox = (e) => {
//         const next = e.target.checked;
//         setChecked(next);
//         if (next) {
//             // copy once when checked
//             copyDestinationToBillTo();
//         }
//         // DO NOT write billToSameAsDestination into formData to avoid hiding fields
//     };

//     // keep in sync while checked: whenever destination changes and checkbox is checked, update billTo
//     useEffect(() => {
//         if (!checked) return;
//         copyDestinationToBillTo();
//     }, [
//         checked,
//         formData.destinationName,
//         formData.destinationAddressLine1,
//         formData.destinationAddressLine2,
//         formData.destinationAddressLine3,
//         formData.destinationAddressLine4,
//         formData.destinationCity,
//         formData.destinationState,
//         formData.destinationCountry,
//         formData.destinationContact,
//         formData.destinationEmail,
//         formData.destination,
//         copyDestinationToBillTo
//     ]);

//     // If formData.billToSameAsDestination externally toggles (e.g., loaded record),
//     // reflect it locally but still do not write it back to formData on user actions.
//     useEffect(() => {
//         if (typeof formData.billToSameAsDestination === 'boolean') {
//             setChecked(!!formData.billToSameAsDestination);
//         }
//     }, [formData.billToSameAsDestination]);

//     return (
//         <div>
//             <div className="mb-3">
//                 <div className="form-check">
//                     <input
//                         id="billToSameAsDestination_local"
//                         name="billToSameAsDestination_local"
//                         type="checkbox"
//                         className="form-check-input"
//                         checked={checked}
//                         onChange={handleCheckbox}
//                     />
//                     <label htmlFor="billToSameAsDestination_local" className="form-check-label">
//                         Bill To same as Destination
//                     </label>
//                 </div>
//             </div>

//             <GenericFormTab
//                 fields={billToFields}
//                 formData={formData}
//                 onChange={onChange}
//                 errors={errors}
//                 readOnly={viewOnly}
//                 isEdit={isEdit} 
//             />
//         </div>
//     );
// }



import React, { useCallback, useEffect, useMemo, useState } from "react";
import { billToFields } from "../formFields/shippmentTabsFields";
import GenericFormTab from "./GenericFormTab";

/**
 * BillToTab
 * - Checkbox: "Same as Destination"
 * - When checked: copy destination -> billTo AND lock Bill To fields (read-only)
 */
export default function BillToTab({
    formData = {},
    onChange,
    errors = {},
    viewOnly = false,
    isEdit = true,
}) {
    const [checked, setChecked] = useState(!!formData.billToSameAsDestination);

    const setMultiple = useCallback(
        (pairs = {}) => {
            Object.entries(pairs).forEach(([name, value]) => {
                onChange({ target: { name, value } });
            });
        },
        [onChange]
    );

    const isPresent = (v) => {
        if (v === undefined || v === null) return false;
        if (typeof v === "string") return v.trim() !== "";
        return true;
    };

    const getDest = (flatName, nestedName) => {
        const flat = formData[flatName];
        if (isPresent(flat)) return flat;
        if (nestedName && formData.destination && isPresent(formData.destination[nestedName])) {
            return formData.destination[nestedName];
        }
        return undefined;
    };

    const copyDestinationToBillTo = useCallback(() => {
        const mapping = {};
        const fields = [
            ["destinationName", "name", "billToName"],
            ["destinationAddressLine1", "addressLine1", "billToAddressLine1"],
            ["destinationAddressLine2", "addressLine2", "billToAddressLine2"],
            ["destinationAddressLine3", "addressLine3", "billToAddressLine3"],
            ["destinationAddressLine4", "addressLine4", "billToAddressLine4"],
            ["destinationCity", "city", "billToCity"],
            ["destinationState", "state", "billToState"],
            ["destinationCountry", "country", "billToCountry"],
            ["destinationContact", "contact", "billToContact"],
            ["destinationEmail", "email", "billToEmail"],
        ];

        fields.forEach(([flat, nested, billKey]) => {
            const destVal = getDest(flat, nested);
            if (isPresent(destVal)) {
                mapping[billKey] = destVal;
            }
        });

        if (Object.keys(mapping).length) setMultiple(mapping);
    }, [formData, getDest, isPresent, setMultiple]);

    const handleCheckbox = (e) => {
        const next = e.target.checked;
        setChecked(next);
        if (next) copyDestinationToBillTo();
    };

    // keep Bill To synced while checked
    useEffect(() => {
        if (!checked) return;
        copyDestinationToBillTo();
    }, [
        checked,
        formData.destinationName,
        formData.destinationAddressLine1,
        formData.destinationAddressLine2,
        formData.destinationAddressLine3,
        formData.destinationAddressLine4,
        formData.destinationCity,
        formData.destinationState,
        formData.destinationCountry,
        formData.destinationContact,
        formData.destinationEmail,
        formData.destination,
        copyDestinationToBillTo,
    ]);

    // reflect loaded record state (if present)
    useEffect(() => {
        if (typeof formData.billToSameAsDestination === "boolean") {
            setChecked(!!formData.billToSameAsDestination);
        }
    }, [formData.billToSameAsDestination]);

    // When checked, mark all Bill To fields read-only
    const billToFieldsLocked = useMemo(
        () =>
            billToFields.map((f) => ({
                ...f,
                readOnly: checked ? true : !!f.readOnly,
            })),
        [checked]
    );

    return (
        <div>
            <div className="mb-3">
                <div className="form-check">
                    <input
                        id="billToSameAsDestination_local"
                        name="billToSameAsDestination_local"
                        type="checkbox"
                        className="form-check-input"
                        checked={checked}
                        onChange={handleCheckbox}
                        disabled={viewOnly}
                    />
                    <label htmlFor="billToSameAsDestination_local" className="form-check-label">
                        Same as Destination
                    </label>
                </div>
            </div>

            <GenericFormTab
                fields={billToFieldsLocked}
                formData={formData}
                onChange={onChange}
                errors={errors}
                readOnly={viewOnly}
                isEdit={isEdit}
            />
        </div>
    );
}
